/* @flow */

import * as React from 'react';
import { useLocation } from 'react-router-dom';

// Styles

// Utils
import { phablet } from '@braindate/ui/lib/token/mediaQuery';

// Components
import {
  SwipeableDrawer,
  Menu,
  MenuItem,
  MenuProps,
  useMediaQuery,
} from '@mui/material';
import MenuPopoverItem from './MenuPopoverItem';

type Props = {
  renderDrawerOnMobile?: boolean,
  children: Array<typeof MenuPopoverItem | typeof MenuItem>,
};

const MenuPopover = ({
  open,
  onClose,
  ariaLabelledby,
  anchorOrigin = {
    vertical: 'top',
    horizontal: 'center',
  },
  transformOrigin = {
    vertical: 'bottom',
    horizontal: 'center',
  },
  children,
  renderDrawerOnMobile = false,
  ...props
}: Props & MenuProps): React.Node => {
  const { pathname } = useLocation();
  const isDesktop = useMediaQuery(phablet);

  const baseProps = {
    open,
    onClose,
    'aria-labelledby': ariaLabelledby,
  };

  /*
  |------------------------------------------------------------------------------
  | Effects
  |------------------------------------------------------------------------------
  */

  React.useEffect(() => {
    onClose();
  }, [pathname]);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return isDesktop || !renderDrawerOnMobile ? (
    <Menu
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      onClose={onClose}
      {...baseProps}
      {...props}
    >
      {children}
    </Menu>
  ) : (
    <SwipeableDrawer
      {...baseProps}
      onOpen={() => {}}
      keepMounted={false}
      disableDiscovery
      disableSwipeToOpen
      anchor="bottom"
    >
      {children}
    </SwipeableDrawer>
  );
};

export default React.memo<Props>(MenuPopover);
